import { mapState } from 'vuex'
/**
 * Sitecore editor mixin
 * Makes the forms not to submit while in Sitecore ExpEditor or Preview modes
 */
export default {
  computed: {
    ...mapState('global', ['isSitecore'])
  },
  methods: {
    /**
     * @vuese
     * Substitute submit action when in sitecore modes
     */
    onSitecoreResponse() {
      this.isLoading = true
      setTimeout(() => {
        this.serverErrors.push({
          message: 'You are in experience editor, submits are not allowed.',
          code: 404
        })
        this.isLoading = false
      }, 2000)
    }
  }
}